<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout column class="eservice_inner_wrap">
      <h2 class="outside_title d-flex type2">
        {{ $t('application.ictopography.title') }}
        <v-spacer></v-spacer>
        <span class="loc_postion">
            <span class="front_loc">{{ $t('application.title') }} > </span>
            <span class="middle_loc">{{ $t('application.ictopography.title2') }} > </span>
            <span class="back_loc">{{ $t('common.common.new') }}</span>
        </span>
      </h2>

      <v-layout column class="ma-0 pos-r center__wrapper">
        <v-flex class="inner_basic_wrap type2">
          <v-layout class="step_wrapper type3">
            <v-flex class="active step_box step01">
              <h2>{{ $t('application.ictopography.fields.step_01') }}</h2>
              <p>
                {{ $t('application.ictopography.fields.select_type_and_input') }}<br/>
                {{ $t('application.ictopography.fields.related_application') }}
              </p>
            </v-flex>
            <v-flex class="step_box step02">
              <h2>{{ $t('application.ictopography.fields.step_02') }}</h2>
              <p>{{ $t('application.ictopography.fields.write_application') }}</p>
            </v-flex>
            <v-flex class="step_box step03">
              <h2>{{ $t('application.ictopography.fields.step_03') }}</h2>
              <p>{{ $t('application.ictopography.fields.attach_files') }}</p>
            </v-flex>
            <v-flex class="step_box step04">
              <h2>{{ $t('application.ictopography.fields.step_04') }}</h2>
              <p>{{ $t('application.ictopography.fields.review_submit') }}</p>
            </v-flex>
            <v-flex class="step_box step05">
              <h2>{{ $t('application.ictopography.fields.step_05') }}</h2>
              <p>{{ $t('application.ictopography.fields.payment') }}</p>
            </v-flex>
          </v-layout>

          <v-layout class="inner_contents mt-30" column>
            <ValidationObserver ref="observer_step1">
              <v-form v-model="valid_step1">
                <!-- TITLE -->
                <h2 class="m_title"><i>*</i> {{ $t('application.ictopography.fields.title') }}</h2>
                <v-flex class="item_box ty2">
                  <ValidationProvider v-slot="{ errors }" :name="$t('application.ictopography.fields.title')" :rules="{required: true}">
                  <div class="text__input__icontype not__ltr">
                    <div class="text__input__icontype__tf">
                      <v-text-field
                        outlined
                        solo
                        flat
                        dense
                        class="type_ar ie_inpt login_text_field text-right br_none"
                        v-model="title_ar"
                        :error-messages="errors"
                      ></v-text-field>
                    </div>
                    <div class="box__title">{{$t('application.ictopography.fields.ar')}}</div>
                  </div>

                  </ValidationProvider>

                  <ValidationProvider v-slot="{ errors }" :name="$t('application.ictopography.fields.title')" :rules="{required: true}">
                  <div class="text__input__icontype not__ltr mt-15">
                    <div class="box__title">{{$t('application.ictopography.fields.en')}}</div>
                    <div class="text__input__icontype__tf">
                      <v-text-field
                        outlined
                        solo
                        flat
                        dense
                        class="br_none ie_inpt login_text_field text-left"
                        v-model="title_en"
                        :error-messages="errors"
                      ></v-text-field>
                    </div>
                  </div>

                  </ValidationProvider>
                </v-flex>

                <!-- Description if the nature if topography -->
                <h2 class="m_title"><i>*</i> {{ $t('application.ictopography.fields.abstract') }}</h2>
                <v-flex class="item_box ty2">

                  <ValidationProvider v-slot="{ errors }" :name="$t('application.ictopography.fields.abstract')" :rules="{required: ((abstract_en) ? false : true)}">
                  <div class="text__textarea__icontype not__ltr">
                    <div class="text__textarea__icontype__tf">
                      <v-textarea
                        outlined
                        class="br_none ie_textarea login_text_field text-right"
                        width="100%"
                        v-model="abstract_ar"
                        :error-messages="errors"
                        no-resize
                      >
                      </v-textarea>
                    </div>
                    <div class="box__title">{{$t('application.ictopography.fields.ar')}}</div>
                  </div>
                  </ValidationProvider>

                  <ValidationProvider v-slot="{ errors }" :name="$t('application.ictopography.fields.abstract')" :rules="{required: ((abstract_ar) ? false : true)}">
                  <div class="text__textarea__icontype not__ltr mt-15">
                    <div class="box__title">{{$t('application.ictopography.fields.en')}}</div>
                    <div class="text__textarea__icontype__tf">
                      <v-textarea
                        outlined
                        class="br_none ie_textarea login_text_field text-left"
                        width="100%"
                        v-model="abstract_en"
                        :error-messages="errors"
                        no-resize
                      >
                      </v-textarea>
                    </div>
                  </div>
                  </ValidationProvider>
                </v-flex>

                <!-- Electronic function of topography -->
                <h2 class="m_title"><i>*</i> {{ $t('application.ictopography.fields.electronic_function') }}</h2>
                <v-flex class="item_box ty2">

                  <ValidationProvider v-slot="{ errors }" :name="$t('application.ictopography.fields.electronic_function')" :rules="{required: true}">
                  <div class="text__textarea__icontype not__ltr">
                    <div class="text__textarea__icontype__tf">
                      <v-textarea
                        outlined
                        class="br_none ie_textarea login_text_field text-right"
                        width="100%"
                        v-model="function_ar"
                        :error-messages="errors"
                        no-resize
                      >
                      </v-textarea>
                    </div>
                    <div class="box__title">{{$t('application.ictopography.fields.ar')}}</div>
                  </div>
                  </ValidationProvider>

                  <ValidationProvider v-slot="{ errors }" :name="$t('application.ictopography.fields.electronic_function')" :rules="{required: true}">
                  <div class="text__textarea__icontype not__ltr mt-15">
                    <div class="box__title">{{$t('application.ictopography.fields.en')}}</div>
                    <div class="text__textarea__icontype__tf">
                      <v-textarea
                        outlined
                        class="br_none ie_textarea login_text_field text-left"
                        width="100%"
                        v-model="function_en"
                        :error-messages="errors"
                        no-resize
                      >
                      </v-textarea>
                    </div>
                  </div>
                  </ValidationProvider>
                </v-flex>
              </v-form>
            </ValidationObserver>
          </v-layout>

          <v-row class="d-block">
            <v-col cols="12" class="mt-40 d-flex">
              <v-spacer></v-spacer>
              <v-btn
                height="50"
                width="150"
                class="btn-normal br_none btn-actv"
                @click="fnSave()"
                :loading="loadingSave"
                :disabled="loadingSave"
              >
                {{ $t('common.button.save') }}
              </v-btn>
              <v-spacer class="hidden_lr5"></v-spacer>
              <v-btn
                color="#a01c2a"
                dark
                min-width="150"
                min-height="50"
                class="btn-normal br_none"
                @click="fnNext()"
                :loading="loadingNext"
                :disabled="loadingNext"
              >
                {{ $t('common.button.save_next') }}
                <v-icon dark right>mdi-check</v-icon>
              </v-btn>
            </v-col>
          </v-row>

        </v-flex>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

export default {
  components :{
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      valid_step1: false,
      loadingSave: false,
      loadingNext: false,
      receipt_no : this.$route.params.receipt_no,

      title_ar : '',
      title_en : '',
      abstract_ar : '',
      abstract_en : '',
      function_ar : '',
      function_en : '',
      ind_abs_translation_ar : 'N',
      ind_abs_translation_en : 'N',
      ind_fnc_translation_ar : 'N',
      ind_fnc_translation_en : 'N'

    }
  },
  mounted(){
    window.scrollTo(0, 0)
    this.fnGetReceipt()
    this.fnGetIC()
  },
  methods: {
    fnGetReceipt(){
      requestApi({
        url: '/receivings/' + this.receipt_no,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            // draft 상태가 아니면 My Request 페이지로 이동
            if (res.data.service_type_code !== '6404'
              || res.data.receipt_status_type_code !== '4301') {
              this.$router.push('/myrequest/list')
            }
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetReceipt()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetIC(){
      requestApi({
        url: '/receivings/ic/'+this.receipt_no+'/filing',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {

            this.title_ar = res.data.title_ar
            this.title_en = res.data.title_en
            this.abstract_ar = res.data.abstract_ar
            this.abstract_en = res.data.abstract_en
            this.function_ar = res.data.function_ar
            this.function_en = res.data.function_en
            this.ind_abs_translation_ar = res.data.ind_abs_translation_ar
            this.ind_abs_translation_en = res.data.ind_abs_translation_en
            this.ind_fnc_translation_ar = res.data.ind_fnc_translation_ar
            this.ind_fnc_translation_en = res.data.ind_fnc_translation_en

          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetIC()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnSave() {
      this.loadingSave = true
      let params = {
        title_ar : this.title_ar,
        title_en : this.title_en,
        abstract_ar : this.abstract_ar,
        abstract_en : this.abstract_en,
        function_ar : this.function_ar,
        function_en : this.function_en,
        ind_abs_translation_ar : utils.isNull(this.ind_abs_translation_ar) ? 'N' : this.ind_abs_translation_ar,
        ind_abs_translation_en : utils.isNull(this.ind_abs_translation_en) ? 'N' : this.ind_abs_translation_en,
        ind_fnc_translation_ar : utils.isNull(this.ind_fnc_translation_ar) ? 'N' : this.ind_fnc_translation_ar,
        ind_fnc_translation_en : utils.isNull(this.ind_fnc_translation_en) ? 'N' : this.ind_fnc_translation_en
      }
      requestApi({
        url: '/receivings/ic/'+this.receipt_no+'/filing/save',
        method: 'PUT',
        data: params,
        callback: (res) => {
          if (res.res_code === '200') {
            let option = {
              text : this.$t('common.message.add.success')
            }
            eventBus.$emit('SHOW_SNACKBAR', option)
            this.loadingSave = false
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnSave()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
              this.loadingSave = false
            }
          }
        }
      })
    },

    fnNext(){
      //다음 단계로 넘어가는 부분은 나중에 구현.. 일단 입력된 정보를 수정 하는 부분까지만..
      this.$refs.observer_step1.validate().then((valid) => {
        if(valid){
          this.loadingNext = true
          let params = {
            title_ar : this.title_ar,
            title_en : this.title_en,
            abstract_ar : this.abstract_ar,
            abstract_en : this.abstract_en,
            function_ar : this.function_ar,
            function_en : this.function_en,
            ind_abs_translation_ar : utils.isNull(this.ind_abs_translation_ar) ? 'N' : this.ind_abs_translation_ar,
            ind_abs_translation_en : utils.isNull(this.ind_abs_translation_en) ? 'N' : this.ind_abs_translation_en,
            ind_fnc_translation_ar : utils.isNull(this.ind_fnc_translation_ar) ? 'N' : this.ind_fnc_translation_ar,
            ind_fnc_translation_en : utils.isNull(this.ind_fnc_translation_en) ? 'N' : this.ind_fnc_translation_en
          }
          requestApi({
            url: '/receivings/ic/'+this.receipt_no+'/filing',
            method: 'PUT',
            data: params,
            callback: (res) => {
              if (res.res_code === '200') {
                this.$router.push("/application/ictopography/step2/"+this.receipt_no)
              } else {
                if (res.res_code === '401012') {
                  utils.setTokenRefresh().then(() => {
                    this.fnNext()
                  })
                } else {
                  eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                  this.loadingNext = false
                }
              }
            }
          })
        } else {
          //2020-11-03 : 첫번째 에러 항목으로 Focus 되도록 추가 수정 (vee-validate 3.0 기반)
          document.getElementsByClassName('error--text')[0].scrollIntoView(false)
        }
      })
    }
  }
}
</script>